import { EnvironmentOptions, Logger, Tracker } from '../types';
import { createTracker } from './tracker';
import getValidators, { initValidateSchema } from '../validation';
import initTransports from '../transport';
import initContextStore from '../stores';
import environmentOptionsSchema from '../validation/schemas/environment-options.schema';
import { addLogger, setBaseLevel } from '../debug';
import initEnrichEvent from '../transformation';

export { voidTracker } from './tracker';

export default (options: EnvironmentOptions, logger?: Logger): Tracker => {
  const environment = environmentOptionsSchema.parse(options);

  if (logger) {
    addLogger(logger);
  }
  setBaseLevel(environment.environment === 'production' ? 'none' : 'info');

  const contextStore = initContextStore();
  const transport = initTransports(environment);
  const enrichEvent = initEnrichEvent({ environment, contextStore });

  return createTracker({
    transport,
    throwOnError: ['local', 'development'].includes(environment.environment),
    validateInput: initValidateSchema(getValidators(), { transport, enrichEvent }),
    enrichEvent,
    contextStore,
  });
};
